import { Component, computed, input, inject, signal } from '@angular/core';

import { ClientRequestItemStatus, RequestSection } from '@aiwyn/api';
import { LaunchDarklyFlag, LaunchDarklyService } from '@aiwyn/config';
import { DATA_SELECTOR_INJECTION_TOKEN } from '@aiwyn/shared';

@Component({
  selector: 'awn-request-section',
  templateUrl: './request-section.component.html',
  styleUrl: './request-section.component.scss',
  providers: [
    {
      provide: DATA_SELECTOR_INJECTION_TOKEN,
      useValue: 'request-section',
    },
  ],
  standalone: false,
})
export class RequestSectionComponent {
  section = input<RequestSection>()
  public dataSelector = inject(DATA_SELECTOR_INJECTION_TOKEN);

  protected enableReferenceId$ = inject(LaunchDarklyService).getFeatureFlag(LaunchDarklyFlag.ENABLE_REFERENCE_ID);

  // Track if section title is expanded on mobile
  isTitleExpanded = signal(false);

  toggleTitleExpansion(): void {
    this.isTitleExpanded.update(value => !value);
  }

  openItemsCount = computed(() =>
    this.section().items?.filter(requestItem => requestItem.status === ClientRequestItemStatus.OPEN).length || 0
  )
  inReviewItemsCount= computed(() =>
    this.section().items?.filter(requestItem => requestItem.status === ClientRequestItemStatus.IN_REVIEW).length || 0
  )
  rejectedItemsCount = computed(() =>
    this.section().items?.filter(requestItem => requestItem.status === ClientRequestItemStatus.REJECTED).length || 0
  )
  approvedItemsCount = computed(() =>
    this.section().items?.filter(requestItem => requestItem.status === ClientRequestItemStatus.DONE).length || 0
  )
}
